<template>
    <div class="cropper-wrapp" v-loading="cropperLoadding">
        <div class="cropper-left">
            <div style="margin-bottom:10px">操作调整:</div>
            <div style="width:410px;height:380px;display:inline-block; margin-bottom:10px;">
                <vueCropper
                ref="cropper"
                :img="option.img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :fixedBox="option.fixedBox"
                :enlarge="option.enlarge"
                @realTime="realTime"
                @imgLoad="imgLoad"
                ></vueCropper>
            </div>
            <div class="cropper-btn">
                <el-button size="small" @click="uploadImgAfter">选择上传</el-button>
                <el-tooltip class="item" effect="dark" content="逆时针旋转" placement="top">
                    <el-button size="small" icon="el-icon-refresh-left"  @click="rotateLeft"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="顺时针旋转" placement="top">
                    <el-button size="small" icon="el-icon-refresh-right" @click="rotateRight"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="放大" placement="top">
                    <el-button size="small" icon="el-icon-zoom-in" @click="changeScale(1)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="缩小" placement="top">
                    <el-button size="small" icon="el-icon-zoom-out" @click="changeScale(-1)"></el-button>
                </el-tooltip>
                <!-- <el-button size="small" icon="el-icon-refresh-left"  @click="rotateLeft"></el-button>
                <el-button size="small" icon="el-icon-refresh-right" @click="rotateRight"></el-button>
                <el-button size="small" icon="el-icon-zoom-in" @click="changeScale(1)"></el-button>
                <el-button size="small" icon="el-icon-zoom-out" @click="changeScale(-1)"></el-button> -->
            </div>
        </div>
        <div class="cropper-right">
            <div class="cropper-right-out">
                <span class="pic-title">圆形预览效果:</span>
                <div class="show-preview">
                    <div :style="previews.div" class="preview">
                        <img :src="previews.url" :style="previews.img">
                    </div>
                </div>
            </div>
            <div class="cropper-right-out">
                <span class="pic-title">方形预览效果:</span>
                <div class="show-preview-fang">
                    <div :style="previews.div" class="preview">
                        <img :src="previews.url" :style="previews.img">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { VueCropper } from 'vue-cropper'
export default {
    name: 'cropperPic',
    data () {
        return {
            cropperLoadding: false,
            option: {
                img: '',
                outputSize: 1, // 剪切后的图片质量（0.1-1）
                full: false, // 输出原图比例截图 props名full
                outputType: 'jpeg',
                canMove: true,
                original: false,
                canMoveBox: true,
                autoCrop: true,
                autoCropWidth: 240,
                autoCropHeight: 240,
                fixedBox: true,
                enlarge: 1
                // fixed: true,
                // fixedNumber: [1, 1] // 截图框比例  (默认:[1:1])
            },
            previews: {},
            imageUrl: '',
            fileName: ''
        }
    },
    components: {
        VueCropper
    },
    props: ['imgFile'],
    methods: {
        // 实时预览函数
        realTime (data) {
            this.previews = data
        },
        imgLoad (msg) {
            console.log(msg)
        },
        changeScale (num) {
            // 图片缩放
            num = num || 1
            this.$refs.cropper.changeScale(num)
        },
        rotateLeft () {
            // 向左旋转
            this.$refs.cropper.rotateLeft()
        },
        rotateRight () {
            // 向右旋转
            this.$refs.cropper.rotateRight()
        },
        uploadImgAfter () {
            this.$refs.cropper.getCropData(data => {
                // console.log(data, '9990000')
                let file = this.dataURLtoFile(data, this.fileName)
                this.cropperLoadding = true
                this.$emit('uploadFile', file)
            })
        },
        dataURLtoFile (dataurl, filename) {
            var arr = dataurl.split(',')
            var mime = arr[0].match(/:(.*?);/)[1]
            var bstr = atob(arr[1])
            var n = bstr.length
            var u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, { type: mime })
        },
        updateOption () {
            // this.file = this.imgFile
            this.option.img = this.imgFile.url
            this.fileName = this.imgFile.name
        }

    }
}
</script>
<style lang="scss">
    .cropper-wrapp {
        display: flex;
        justify-content: center;
        .cropper-left {
            margin-bottom: 20px;
            margin-right: 60px;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            .cropper-btn {
                display: flex;
                justify-content: center;
                .el-button--small {
                        // width: 86px;
                        // height: px;
                        height: 32px;
                        font-size: 14px;
                        padding: 8px 15px;
                }
            }
        }
        .cropper-right {
            // display: flex;
            .cropper-right-out {
                margin-top: 40px;
                height: 142px;
                width: 122px;
            }
            .show-preview{
                margin-right: 20px;
                width: 244px;
                height: 244px;
                overflow: hidden;
                zoom: .5;
                .preview{
                    overflow: hidden;
                    border-radius: 50%;
                    border:1px solid #cccccc;
                    background: #cccccc;
                }
            }
            .show-preview-fang {
                width: 242px;
                height: 242px;
                overflow: hidden;
                border:1px solid #cccccc;
                zoom: .5;
                .preview{
                    overflow: hidden;
                    border:1px solid #cccccc;
                    background: #cccccc;
                }
            }
            .pic-title {
                margin-bottom: 10px;
                display: inline-block;
                width: 122px;
                text-align: center;
            }
        }
    }
</style>
